import FormInputTypes from '../components/atoms/formEnums/formInputTypes';

export default {
  title: 'Onboarding and About sections',
  attributeName: 'infoPages',
  helpText: '',
  fields: [
    // {
    //   attributeName: 'externalLinks',
    //   type: FormInputTypes.TABLE,
    //   label: '',
    //   helpText: '',
    //   configFile: tableAppLinks,
    // },
    {
      attributeName: 'onboardingImageMobile',
      type: FormInputTypes.DOWNLOADABLE,
      label: 'Onboarding image mobile (260x280 px)',
      helpText: 'Add an image for the onboarding section.',     
      hasSelect:false,
      fileType: ['.jpg', '.jpeg', '.png'],
    },
    {
      attributeName: 'onboardingImageTablet',
      type: FormInputTypes.DOWNLOADABLE,
      label: 'Onboarding image tablet (520x538 px)',
      helpText: 'Add an image for the onboarding section.',     
      hasSelect:false,
      fileType: ['.jpg', '.jpeg', '.png'],
    },
    
    {
      attributeName: 'onboardingSection',
      type: FormInputTypes.TEXT_EDITOR,
      label: 'Onboarding section',
      toolbar:['heading', 'alignment', 'bold', 'italic', 'link'],
      placeholder: 'Video description...',
      helpText: 'Description of the video.',
    },
    {
      attributeName: 'aboutSectionImageMobile',
      type: FormInputTypes.DOWNLOADABLE,
      label: 'About section image mobile (360x282 px)',
      helpText: 'Add an image for the onboarding section.',     
      hasSelect:false,
      fileType: ['.jpg', '.jpeg', '.png'],
    },
    {
      attributeName: 'aboutSectionImageTabletPortrait',
      type: FormInputTypes.DOWNLOADABLE,
      label: 'About section image Tablet (720x562 px)',
      helpText: 'Add an image for the onboarding section.',     
      hasSelect:false,
      fileType: ['.jpg', '.jpeg', '.png'],
    },
    {
      attributeName: 'aboutSectionImageTabletLandscape',
      type: FormInputTypes.DOWNLOADABLE,
      label: 'About section image Tablet Landscape(926x328 px)',
      helpText: 'Add an image for the onboarding section.',     
      hasSelect:false,
      fileType: ['.jpg', '.jpeg', '.png'],
    },
    {
      attributeName: 'aboutSection',
      type: FormInputTypes.TEXT_EDITOR,
      label: 'About section',
      toolbar:['heading', 'alignment', 'bold', 'italic', 'link'],
      placeholder: 'Video description...',
      helpText: 'Description of the video.',
    }    
  ],
};
